import React, { useState, useEffect, useRef } from 'react'
import { errorEmitter } from '../../../services/axios-instance'
import './global-error-modal.scss'

const GlobalErrorModal = () => {
	const [error, setError] = useState(null)
	const buttonRef = useRef(null)

	useEffect(() => {
		const handleError = event => {
			setError(event.detail.message)
		}

		errorEmitter.addEventListener('apiError', handleError)

		return () => {
			errorEmitter.removeEventListener('apiError', handleError)
		}
	}, [])

	useEffect(() => {
		if (error) {
			document.body.style.overflow = 'hidden'
			setTimeout(() => {
				buttonRef.current?.focus()
			}, 100)
		} else {
			document.body.style.overflow = 'initial'
		}

		return () => {
			document.body.style.overflow = 'initial'
		}
	}, [error])

	const closeModal = () => {
		setError(null)
	}

	if (!error) return null

	return (
		<div
			className="f-global-error-modal"
			role="dialog"
			aria-modal="true"
			aria-labelledby="error-modal-title"
			aria-describedby="error-modal-message"
		>
			<div className="f-global-error-modal__content">
				<h4 id="error-modal-title" className="f-global-error-modal__title">
					¡Ups! Algo salió mal
				</h4>
				<p id="error-modal-message" className="f-global-error-modal__message">
					{error}
				</p>
				<button
					ref={buttonRef}
					onClick={closeModal}
					className="f-global-error-modal__button"
					type="button"
				>
					Aceptar
				</button>
			</div>
		</div>
	)
}

export default GlobalErrorModal
